export default __webpack_public_path__ + "static/media/Horn of the Warded Brute.30ab8e68.jpg";